import { render, staticRenderFns } from "./PasswordChangeCmp.vue?vue&type=template&id=ddb90c14"
import script from "./PasswordChangeCmp.vue?vue&type=script&lang=js"
export * from "./PasswordChangeCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports